module.exports = __webpack_public_path__ + "img/wbicon-huadu.7af58318.jpg";